import { call, put, takeLatest } from "redux-saga/effects";
import {
  createSectionStart,
  createSectionMediaStart,
  createSectionMediaSuccess,
  createSectionMediaFailure,
} from "../reducer";
import { networkErrorHandler } from "../../../utils/errorHandlers";
import { httpCreateSectionImage } from "../../../services/section";
import { httpPostAudioFile } from "../../../services/audio";
import { createAudioSuccess, createAudioFailure } from "../../audio/reducer";

export function* handleCreateMedia({ payload }) {
  const { data, callback } = payload;

  const imageFile = data?.imageUrl;
  const audioObj = data?.multimediaFile;
  let multimediaFileId;
  let imageUrl;

  // Check for audio file and make API request if needed
  if (audioObj?.file) {
    if (audioObj.upload) {
      const responseAudio = yield call(httpPostAudioFile, audioObj.file);
      const { success, raw, message } = responseAudio;

      multimediaFileId = raw?.id;
      if (success) {
        yield put(createAudioSuccess());
      } else {
        yield put(createAudioFailure());
        networkErrorHandler(responseAudio.statusCode, message || raw?.error);
        return; // Exit the function if audio creation fails
      }
    }
  }

  // Check if image file exists and make API request if needed
  if (imageFile) {
    const responseImage = yield call(httpCreateSectionImage, imageFile);
    const { success, raw, message } = responseImage;
    if (success) {
      imageUrl = raw?.id;
      yield put(createSectionMediaSuccess());
    } else {
      yield put(createSectionMediaFailure());
      networkErrorHandler(responseImage.statusCode, message || raw?.error);
      return; // Exit the function if image creation fails
    }
  }
  let modData = { ...data, imageUrl, multimediaFileId };

  yield put(createSectionStart({ data: modData, callback }));
}

export default function* onCreateSectionMedia() {
  yield takeLatest(createSectionMediaStart.type, handleCreateMedia);
}
